import React from 'react';
import { TrendingDown, Settings, Palette, Shirt, Users, Store } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const BENEFITS = [{
  icon: TrendingDown,
  title: 'Beat the Quote',
  desc: 'Send a comparable quote and our team will help you get the best deal possible without sacrificing quality.'
}, {
  icon: Settings,
  title: 'Factory Direct Control',
  desc: 'Fewer middlemen, better pricing, and more control over production timelines and quality.'
}, {
  icon: Palette,
  title: 'Custom Artwork Support',
  desc: 'Work directly with our art team to create or refine your custom uniform design.'
}, {
  icon: Shirt,
  title: 'Samples Before You Commit',
  desc: 'Use product samples, size samples, and approvals to make better decisions before full production.'
}, {
  icon: Users,
  title: 'Built for Team Orders',
  desc: 'Sizes, colors, names, numbers, and approvals are handled through an organized, stress-free order process.'
}, {
  icon: Store,
  title: 'Team Stores & Fundraising',
  desc: 'Open custom online stores so fans, families, and players can order gear while raising funds.'
}];
export function WhyChoosePts() {
  return <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-276">
      <Container data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-279">
            Why Teams Choose PTS
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-280"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-281">
            We take the stress out of ordering custom team uniforms with
            factory-direct pricing and dedicated support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-282">
          {BENEFITS.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-283">
              <div className="w-14 h-14 bg-red-50 text-pts-red rounded-lg flex items-center justify-center mb-6" data-id="element-284">
                <benefit.icon className="h-7 w-7" data-id="element-285" />
              </div>
              <h3 className="font-oswald text-2xl font-bold text-gray-900 uppercase mb-3" data-id="element-286">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-287">{benefit.desc}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}